import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import { Observable } from 'rxjs';
import { ICostCenterGroup } from '../../../../models/cost-center-group.model';
import { ICostCenterState } from '../../../../services/facades/master-data/cost-center-state.model';
import { CostCenterFacade } from '../../../../services/facades/master-data/cost-center.facade';

@Component({
    selector: 'app-cost-center-group-dialog',
    templateUrl: './cost-center-group-dialog.component.html',
    styleUrls: [ './cost-center-group-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostCenterGroupDialogComponent implements OnInit, AfterViewInit {
    public costCenterState$: Observable<ICostCenterState>;
    public formGroup: FormGroup;
    public dialogFieldsValid: boolean = false;


    constructor(
        private myMatDialogRef: MatDialogRef<CostCenterGroupDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ICostCenterGroup,
        private myCostCenterFacade: CostCenterFacade,
    ) {
    }

    public ngOnInit(): void {
        this.costCenterState$ = this.myCostCenterFacade.subState();
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((costCenterGroup: ICostCenterGroup) => {
            this.validateDialogFields(costCenterGroup);
        });
    }

    public async save(): Promise<void> {
        const data = this.formGroup.value as ICostCenterGroup;
        if (isNullOrUndefined(this.data.id)) {
            await this.myCostCenterFacade.addKostenstellengruppe(data);
        } else {
            data.id = this.data.id;
            await this.myCostCenterFacade.editKostenstellengruppe(data);
        }
        this.myMatDialogRef.close(true);

    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    private validateDialogFields(costCenterGroup: ICostCenterGroup): void {
        // Validations to disable saving/editing
        if (!costCenterGroup.name || !costCenterGroup.processOrder) {
            this.dialogFieldsValid = false;
        } else {
            this.dialogFieldsValid = true;
        }
    }
}
